/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { DoubleSide } from 'three';
let ShapeArc = class ShapeArc extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const geometry = Solids.createCircle(shape.radius, 32, shape.angle, shape.deltaAngle);
        geometry.translate(shape.cx, shape.cy, 0);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide, depthWrite: false });
        this.addOutline(geometry, decoration);
    }
    format() {
        return undefined;
    }
};
ShapeArc = tslib_1.__decorate([
    Shape('Shape.Arc'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], ShapeArc);
export { ShapeArc };
//# sourceMappingURL=ShapeArc.js.map